export default __webpack_public_path__ + "static/media/ContentLibraryDarkInActive.3daaff99.svg";